import { IFilter } from '../types';

export const filterConfiguration = <P>(
  component: React.ComponentClass<P>,
  optionsEndpoint?: (id: number) => string,  
  postfix?: string[],
  categoryOptionsEndpoint?: (id: number) => string,
  displayCategories?: boolean
) => {
  return {
    component,
    optionsEndpoint,
    postfix,
    categoryOptionsEndpoint,
    displayCategories
  } as IFilter;
};
